// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "project_management.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "project_management.proto" (syntax proto3)
// tslint:disable
import { Int32 } from "./common";
import { String$ } from "./common";
import { Bool } from "./common";
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ProjectEvent } from "./event";
import { Event } from "./event";
import { User } from "./user";
import { TimesheetDepartment } from "./timesheet_department";
// @generated message type with reflection information, may provide speed optimized methods
class ProjectDepartmentAssignment$Type extends MessageType {
    constructor() {
        super("ProjectDepartmentAssignment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "allocated_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "allocated_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "department", kind: "message", T: () => TimesheetDepartment },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.projectEventId = 0;
        message.departmentId = 0;
        message.allocatedHours = 0;
        message.allocatedBudget = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 project_event_id */ 2:
                    message.projectEventId = reader.int32();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* double allocated_hours */ 4:
                    message.allocatedHours = reader.double();
                    break;
                case /* double allocated_budget */ 5:
                    message.allocatedBudget = reader.double();
                    break;
                case /* string created_at */ 6:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 7:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* TimesheetDepartment department */ 9:
                    message.department = TimesheetDepartment.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 12:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 project_event_id = 2; */
        if (message.projectEventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectEventId);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* double allocated_hours = 4; */
        if (message.allocatedHours !== 0)
            writer.tag(4, WireType.Bit64).double(message.allocatedHours);
        /* double allocated_budget = 5; */
        if (message.allocatedBudget !== 0)
            writer.tag(5, WireType.Bit64).double(message.allocatedBudget);
        /* string created_at = 6; */
        if (message.createdAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 7; */
        if (message.updatedAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* TimesheetDepartment department = 9; */
        if (message.department)
            TimesheetDepartment.internalBinaryWrite(message.department, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 12; */
        if (message.withoutLimit !== false)
            writer.tag(12, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectDepartmentAssignment
 */
export const ProjectDepartmentAssignment = new ProjectDepartmentAssignment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectDepartmentAssignmentList$Type extends MessageType {
    constructor() {
        super("ProjectDepartmentAssignmentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectDepartmentAssignment },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectDepartmentAssignment results */ 1:
                    message.results.push(ProjectDepartmentAssignment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectDepartmentAssignment results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectDepartmentAssignment.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectDepartmentAssignmentList
 */
export const ProjectDepartmentAssignmentList = new ProjectDepartmentAssignmentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkDepartmentAssignRequest$Type extends MessageType {
    constructor() {
        super("BulkDepartmentAssignRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "assignments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentBudgetAllocation }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.assignments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* repeated DepartmentBudgetAllocation assignments */ 2:
                    message.assignments.push(DepartmentBudgetAllocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* repeated DepartmentBudgetAllocation assignments = 2; */
        for (let i = 0; i < message.assignments.length; i++)
            DepartmentBudgetAllocation.internalBinaryWrite(message.assignments[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BulkDepartmentAssignRequest
 */
export const BulkDepartmentAssignRequest = new BulkDepartmentAssignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentBudgetAllocation$Type extends MessageType {
    constructor() {
        super("DepartmentBudgetAllocation", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "allocated_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "allocated_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.allocatedHours = 0;
        message.allocatedBudget = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* double allocated_hours */ 2:
                    message.allocatedHours = reader.double();
                    break;
                case /* double allocated_budget */ 3:
                    message.allocatedBudget = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* double allocated_hours = 2; */
        if (message.allocatedHours !== 0)
            writer.tag(2, WireType.Bit64).double(message.allocatedHours);
        /* double allocated_budget = 3; */
        if (message.allocatedBudget !== 0)
            writer.tag(3, WireType.Bit64).double(message.allocatedBudget);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentBudgetAllocation
 */
export const DepartmentBudgetAllocation = new DepartmentBudgetAllocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BudgetCalculationRequest$Type extends MessageType {
    constructor() {
        super("BudgetCalculationRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "include_actuals", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_variance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "include_itemized_breakdown", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.includeActuals = false;
        message.includeVariance = false;
        message.departmentIds = [];
        message.includeItemizedBreakdown = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* bool include_actuals */ 2:
                    message.includeActuals = reader.bool();
                    break;
                case /* bool include_variance */ 3:
                    message.includeVariance = reader.bool();
                    break;
                case /* repeated int32 department_ids */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIds.push(reader.int32());
                    else
                        message.departmentIds.push(reader.int32());
                    break;
                case /* bool include_itemized_breakdown */ 5:
                    message.includeItemizedBreakdown = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* bool include_actuals = 2; */
        if (message.includeActuals !== false)
            writer.tag(2, WireType.Varint).bool(message.includeActuals);
        /* bool include_variance = 3; */
        if (message.includeVariance !== false)
            writer.tag(3, WireType.Varint).bool(message.includeVariance);
        /* repeated int32 department_ids = 4; */
        if (message.departmentIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIds.length; i++)
                writer.int32(message.departmentIds[i]);
            writer.join();
        }
        /* bool include_itemized_breakdown = 5; */
        if (message.includeItemizedBreakdown !== false)
            writer.tag(5, WireType.Varint).bool(message.includeItemizedBreakdown);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BudgetCalculationRequest
 */
export const BudgetCalculationRequest = new BudgetCalculationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BudgetBreakdown$Type extends MessageType {
    constructor() {
        super("BudgetBreakdown", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "budgeted_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "budgeted_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "actual_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "actual_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "variance_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "variance_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "hourly_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.departmentName = "";
        message.budgetedHours = 0;
        message.budgetedAmount = 0;
        message.actualHours = 0;
        message.actualAmount = 0;
        message.varianceHours = 0;
        message.varianceAmount = 0;
        message.hourlyRate = 0;
        message.percentComplete = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 2:
                    message.departmentName = reader.string();
                    break;
                case /* double budgeted_hours */ 3:
                    message.budgetedHours = reader.double();
                    break;
                case /* double budgeted_amount */ 4:
                    message.budgetedAmount = reader.double();
                    break;
                case /* double actual_hours */ 5:
                    message.actualHours = reader.double();
                    break;
                case /* double actual_amount */ 6:
                    message.actualAmount = reader.double();
                    break;
                case /* double variance_hours */ 7:
                    message.varianceHours = reader.double();
                    break;
                case /* double variance_amount */ 8:
                    message.varianceAmount = reader.double();
                    break;
                case /* double hourly_rate */ 9:
                    message.hourlyRate = reader.double();
                    break;
                case /* double percent_complete */ 10:
                    message.percentComplete = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string department_name = 2; */
        if (message.departmentName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentName);
        /* double budgeted_hours = 3; */
        if (message.budgetedHours !== 0)
            writer.tag(3, WireType.Bit64).double(message.budgetedHours);
        /* double budgeted_amount = 4; */
        if (message.budgetedAmount !== 0)
            writer.tag(4, WireType.Bit64).double(message.budgetedAmount);
        /* double actual_hours = 5; */
        if (message.actualHours !== 0)
            writer.tag(5, WireType.Bit64).double(message.actualHours);
        /* double actual_amount = 6; */
        if (message.actualAmount !== 0)
            writer.tag(6, WireType.Bit64).double(message.actualAmount);
        /* double variance_hours = 7; */
        if (message.varianceHours !== 0)
            writer.tag(7, WireType.Bit64).double(message.varianceHours);
        /* double variance_amount = 8; */
        if (message.varianceAmount !== 0)
            writer.tag(8, WireType.Bit64).double(message.varianceAmount);
        /* double hourly_rate = 9; */
        if (message.hourlyRate !== 0)
            writer.tag(9, WireType.Bit64).double(message.hourlyRate);
        /* double percent_complete = 10; */
        if (message.percentComplete !== 0)
            writer.tag(10, WireType.Bit64).double(message.percentComplete);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BudgetBreakdown
 */
export const BudgetBreakdown = new BudgetBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectBudgetSummary$Type extends MessageType {
    constructor() {
        super("ProjectBudgetSummary", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total_actual", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total_variance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "department_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BudgetBreakdown },
            { no: 7, name: "last_calculated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_over_budget", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "itemized_breakdown", kind: "message", T: () => ItemizedActualsBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.totalBudget = 0;
        message.totalActual = 0;
        message.totalVariance = 0;
        message.percentComplete = 0;
        message.departmentBreakdown = [];
        message.lastCalculated = "";
        message.isOverBudget = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* double total_budget */ 2:
                    message.totalBudget = reader.double();
                    break;
                case /* double total_actual */ 3:
                    message.totalActual = reader.double();
                    break;
                case /* double total_variance */ 4:
                    message.totalVariance = reader.double();
                    break;
                case /* double percent_complete */ 5:
                    message.percentComplete = reader.double();
                    break;
                case /* repeated BudgetBreakdown department_breakdown */ 6:
                    message.departmentBreakdown.push(BudgetBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string last_calculated */ 7:
                    message.lastCalculated = reader.string();
                    break;
                case /* bool is_over_budget */ 8:
                    message.isOverBudget = reader.bool();
                    break;
                case /* ItemizedActualsBreakdown itemized_breakdown */ 9:
                    message.itemizedBreakdown = ItemizedActualsBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.itemizedBreakdown);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* double total_budget = 2; */
        if (message.totalBudget !== 0)
            writer.tag(2, WireType.Bit64).double(message.totalBudget);
        /* double total_actual = 3; */
        if (message.totalActual !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalActual);
        /* double total_variance = 4; */
        if (message.totalVariance !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalVariance);
        /* double percent_complete = 5; */
        if (message.percentComplete !== 0)
            writer.tag(5, WireType.Bit64).double(message.percentComplete);
        /* repeated BudgetBreakdown department_breakdown = 6; */
        for (let i = 0; i < message.departmentBreakdown.length; i++)
            BudgetBreakdown.internalBinaryWrite(message.departmentBreakdown[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string last_calculated = 7; */
        if (message.lastCalculated !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.lastCalculated);
        /* bool is_over_budget = 8; */
        if (message.isOverBudget !== false)
            writer.tag(8, WireType.Varint).bool(message.isOverBudget);
        /* ItemizedActualsBreakdown itemized_breakdown = 9; */
        if (message.itemizedBreakdown)
            ItemizedActualsBreakdown.internalBinaryWrite(message.itemizedBreakdown, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectBudgetSummary
 */
export const ProjectBudgetSummary = new ProjectBudgetSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemizedActualsBreakdown$Type extends MessageType {
    constructor() {
        super("ItemizedActualsBreakdown", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "direct_labor", kind: "message", T: () => ItemizedCategoryBreakdown },
            { no: 3, name: "indirect_labor", kind: "message", T: () => ItemizedCategoryBreakdown },
            { no: 4, name: "materials", kind: "message", T: () => ItemizedCategoryBreakdown },
            { no: 5, name: "equipment", kind: "message", T: () => ItemizedCategoryBreakdown },
            { no: 6, name: "subcontractor", kind: "message", T: () => ItemizedCategoryBreakdown },
            { no: 7, name: "general_expense", kind: "message", T: () => ItemizedCategoryBreakdown },
            { no: 8, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "total_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "last_calculated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "general_expense_extras", kind: "message", T: () => GeneralExpenseExtras }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.totalAmount = 0;
        message.totalHours = 0;
        message.lastCalculated = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* ItemizedCategoryBreakdown direct_labor */ 2:
                    message.directLabor = ItemizedCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.directLabor);
                    break;
                case /* ItemizedCategoryBreakdown indirect_labor */ 3:
                    message.indirectLabor = ItemizedCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.indirectLabor);
                    break;
                case /* ItemizedCategoryBreakdown materials */ 4:
                    message.materials = ItemizedCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.materials);
                    break;
                case /* ItemizedCategoryBreakdown equipment */ 5:
                    message.equipment = ItemizedCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.equipment);
                    break;
                case /* ItemizedCategoryBreakdown subcontractor */ 6:
                    message.subcontractor = ItemizedCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.subcontractor);
                    break;
                case /* ItemizedCategoryBreakdown general_expense */ 7:
                    message.generalExpense = ItemizedCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options, message.generalExpense);
                    break;
                case /* double total_amount */ 8:
                    message.totalAmount = reader.double();
                    break;
                case /* double total_hours */ 9:
                    message.totalHours = reader.double();
                    break;
                case /* string last_calculated */ 10:
                    message.lastCalculated = reader.string();
                    break;
                case /* GeneralExpenseExtras general_expense_extras */ 11:
                    message.generalExpenseExtras = GeneralExpenseExtras.internalBinaryRead(reader, reader.uint32(), options, message.generalExpenseExtras);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* ItemizedCategoryBreakdown direct_labor = 2; */
        if (message.directLabor)
            ItemizedCategoryBreakdown.internalBinaryWrite(message.directLabor, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* ItemizedCategoryBreakdown indirect_labor = 3; */
        if (message.indirectLabor)
            ItemizedCategoryBreakdown.internalBinaryWrite(message.indirectLabor, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* ItemizedCategoryBreakdown materials = 4; */
        if (message.materials)
            ItemizedCategoryBreakdown.internalBinaryWrite(message.materials, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* ItemizedCategoryBreakdown equipment = 5; */
        if (message.equipment)
            ItemizedCategoryBreakdown.internalBinaryWrite(message.equipment, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* ItemizedCategoryBreakdown subcontractor = 6; */
        if (message.subcontractor)
            ItemizedCategoryBreakdown.internalBinaryWrite(message.subcontractor, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ItemizedCategoryBreakdown general_expense = 7; */
        if (message.generalExpense)
            ItemizedCategoryBreakdown.internalBinaryWrite(message.generalExpense, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* double total_amount = 8; */
        if (message.totalAmount !== 0)
            writer.tag(8, WireType.Bit64).double(message.totalAmount);
        /* double total_hours = 9; */
        if (message.totalHours !== 0)
            writer.tag(9, WireType.Bit64).double(message.totalHours);
        /* string last_calculated = 10; */
        if (message.lastCalculated !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.lastCalculated);
        /* GeneralExpenseExtras general_expense_extras = 11; */
        if (message.generalExpenseExtras)
            GeneralExpenseExtras.internalBinaryWrite(message.generalExpenseExtras, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ItemizedActualsBreakdown
 */
export const ItemizedActualsBreakdown = new ItemizedActualsBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneralExpenseExtras$Type extends MessageType {
    constructor() {
        super("GeneralExpenseExtras", [
            { no: 1, name: "spiffs", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "per_diem", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "lodging", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.spiffs = 0;
        message.perDiem = 0;
        message.lodging = 0;
        message.total = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double spiffs */ 1:
                    message.spiffs = reader.double();
                    break;
                case /* double per_diem */ 2:
                    message.perDiem = reader.double();
                    break;
                case /* double lodging */ 3:
                    message.lodging = reader.double();
                    break;
                case /* double total */ 4:
                    message.total = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double spiffs = 1; */
        if (message.spiffs !== 0)
            writer.tag(1, WireType.Bit64).double(message.spiffs);
        /* double per_diem = 2; */
        if (message.perDiem !== 0)
            writer.tag(2, WireType.Bit64).double(message.perDiem);
        /* double lodging = 3; */
        if (message.lodging !== 0)
            writer.tag(3, WireType.Bit64).double(message.lodging);
        /* double total = 4; */
        if (message.total !== 0)
            writer.tag(4, WireType.Bit64).double(message.total);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GeneralExpenseExtras
 */
export const GeneralExpenseExtras = new GeneralExpenseExtras$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ItemizedCategoryBreakdown$Type extends MessageType {
    constructor() {
        super("ItemizedCategoryBreakdown", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "transaction_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "cost_center_codes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.amount = 0;
        message.hours = 0;
        message.transactionCount = 0;
        message.costCenterCodes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double amount */ 1:
                    message.amount = reader.double();
                    break;
                case /* double hours */ 2:
                    message.hours = reader.double();
                    break;
                case /* int32 transaction_count */ 3:
                    message.transactionCount = reader.int32();
                    break;
                case /* repeated string cost_center_codes */ 4:
                    message.costCenterCodes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double amount = 1; */
        if (message.amount !== 0)
            writer.tag(1, WireType.Bit64).double(message.amount);
        /* double hours = 2; */
        if (message.hours !== 0)
            writer.tag(2, WireType.Bit64).double(message.hours);
        /* int32 transaction_count = 3; */
        if (message.transactionCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.transactionCount);
        /* repeated string cost_center_codes = 4; */
        for (let i = 0; i < message.costCenterCodes.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.costCenterCodes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ItemizedCategoryBreakdown
 */
export const ItemizedCategoryBreakdown = new ItemizedCategoryBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectActivity$Type extends MessageType {
    constructor() {
        super("ProjectActivity", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "activity_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "metadata", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "creator", kind: "message", T: () => User },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.projectEventId = 0;
        message.activityType = "";
        message.title = "";
        message.description = "";
        message.metadata = "";
        message.createdBy = 0;
        message.createdAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 project_event_id */ 2:
                    message.projectEventId = reader.int32();
                    break;
                case /* string activity_type */ 3:
                    message.activityType = reader.string();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string metadata */ 6:
                    message.metadata = reader.string();
                    break;
                case /* int32 created_by */ 7:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* User creator */ 9:
                    message.creator = User.internalBinaryRead(reader, reader.uint32(), options, message.creator);
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 12:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string order_by */ 13:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 14:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 project_event_id = 2; */
        if (message.projectEventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectEventId);
        /* string activity_type = 3; */
        if (message.activityType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.activityType);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string metadata = 6; */
        if (message.metadata !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.metadata);
        /* int32 created_by = 7; */
        if (message.createdBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.createdBy);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* User creator = 9; */
        if (message.creator)
            User.internalBinaryWrite(message.creator, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 12; */
        if (message.withoutLimit !== false)
            writer.tag(12, WireType.Varint).bool(message.withoutLimit);
        /* string order_by = 13; */
        if (message.orderBy !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 14; */
        if (message.orderDir !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectActivity
 */
export const ProjectActivity = new ProjectActivity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectActivityList$Type extends MessageType {
    constructor() {
        super("ProjectActivityList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectActivity },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectActivity results */ 1:
                    message.results.push(ProjectActivity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectActivity results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectActivity.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectActivityList
 */
export const ProjectActivityList = new ProjectActivityList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatusChangeRequest$Type extends MessageType {
    constructor() {
        super("StatusChangeRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "old_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "new_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "changed_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.oldStatus = "";
        message.newStatus = "";
        message.changedBy = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* string old_status */ 2:
                    message.oldStatus = reader.string();
                    break;
                case /* string new_status */ 3:
                    message.newStatus = reader.string();
                    break;
                case /* int32 changed_by */ 4:
                    message.changedBy = reader.int32();
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* string old_status = 2; */
        if (message.oldStatus !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.oldStatus);
        /* string new_status = 3; */
        if (message.newStatus !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.newStatus);
        /* int32 changed_by = 4; */
        if (message.changedBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.changedBy);
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StatusChangeRequest
 */
export const StatusChangeRequest = new StatusChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BudgetUpdateRequest$Type extends MessageType {
    constructor() {
        super("BudgetUpdateRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "old_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "new_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.oldBudget = 0;
        message.newBudget = 0;
        message.updatedBy = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* double old_budget */ 2:
                    message.oldBudget = reader.double();
                    break;
                case /* double new_budget */ 3:
                    message.newBudget = reader.double();
                    break;
                case /* int32 updated_by */ 4:
                    message.updatedBy = reader.int32();
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* double old_budget = 2; */
        if (message.oldBudget !== 0)
            writer.tag(2, WireType.Bit64).double(message.oldBudget);
        /* double new_budget = 3; */
        if (message.newBudget !== 0)
            writer.tag(3, WireType.Bit64).double(message.newBudget);
        /* int32 updated_by = 4; */
        if (message.updatedBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.updatedBy);
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BudgetUpdateRequest
 */
export const BudgetUpdateRequest = new BudgetUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectInvoice$Type extends MessageType {
    constructor() {
        super("ProjectInvoice", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "sent_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "paid_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "unity_build_invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "retainage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 20, name: "revision_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "qb_invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.projectEventId = 0;
        message.invoiceNumber = "";
        message.invoiceDate = "";
        message.amount = "";
        message.status = "";
        message.sentDate = "";
        message.paidDate = "";
        message.description = "";
        message.unityBuildInvoiceId = "";
        message.createdBy = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.projectId = 0;
        message.userId = 0;
        message.retainage = 0;
        message.revisionCount = 0;
        message.qbInvoiceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 project_event_id */ 2:
                    message.projectEventId = reader.int32();
                    break;
                case /* string invoice_number */ 3:
                    message.invoiceNumber = reader.string();
                    break;
                case /* string invoice_date */ 4:
                    message.invoiceDate = reader.string();
                    break;
                case /* string amount */ 5:
                    message.amount = reader.string();
                    break;
                case /* string status = 6 [deprecated = true] */ 6:
                    message.status = reader.string();
                    break;
                case /* string sent_date = 7 [deprecated = true] */ 7:
                    message.sentDate = reader.string();
                    break;
                case /* string paid_date = 8 [deprecated = true] */ 8:
                    message.paidDate = reader.string();
                    break;
                case /* string description */ 9:
                    message.description = reader.string();
                    break;
                case /* string unity_build_invoice_id = 10 [deprecated = true] */ 10:
                    message.unityBuildInvoiceId = reader.string();
                    break;
                case /* int32 created_by = 11 [deprecated = true] */ 11:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at = 12 [deprecated = true] */ 12:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at = 13 [deprecated = true] */ 13:
                    message.updatedAt = reader.string();
                    break;
                case /* repeated string field_mask */ 14:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 15:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 16:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 project_id */ 17:
                    message.projectId = reader.int32();
                    break;
                case /* int32 user_id */ 18:
                    message.userId = reader.int32();
                    break;
                case /* double retainage */ 19:
                    message.retainage = reader.double();
                    break;
                case /* int32 revision_count */ 20:
                    message.revisionCount = reader.int32();
                    break;
                case /* string qb_invoice_id */ 21:
                    message.qbInvoiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 project_event_id = 2; */
        if (message.projectEventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectEventId);
        /* string invoice_number = 3; */
        if (message.invoiceNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.invoiceNumber);
        /* string invoice_date = 4; */
        if (message.invoiceDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.invoiceDate);
        /* string amount = 5; */
        if (message.amount !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.amount);
        /* string status = 6 [deprecated = true]; */
        if (message.status !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.status);
        /* string sent_date = 7 [deprecated = true]; */
        if (message.sentDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.sentDate);
        /* string paid_date = 8 [deprecated = true]; */
        if (message.paidDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.paidDate);
        /* string description = 9; */
        if (message.description !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.description);
        /* string unity_build_invoice_id = 10 [deprecated = true]; */
        if (message.unityBuildInvoiceId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.unityBuildInvoiceId);
        /* int32 created_by = 11 [deprecated = true]; */
        if (message.createdBy !== 0)
            writer.tag(11, WireType.Varint).int32(message.createdBy);
        /* string created_at = 12 [deprecated = true]; */
        if (message.createdAt !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 13 [deprecated = true]; */
        if (message.updatedAt !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.updatedAt);
        /* repeated string field_mask = 14; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 15; */
        if (message.pageNumber !== 0)
            writer.tag(15, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 16; */
        if (message.withoutLimit !== false)
            writer.tag(16, WireType.Varint).bool(message.withoutLimit);
        /* int32 project_id = 17; */
        if (message.projectId !== 0)
            writer.tag(17, WireType.Varint).int32(message.projectId);
        /* int32 user_id = 18; */
        if (message.userId !== 0)
            writer.tag(18, WireType.Varint).int32(message.userId);
        /* double retainage = 19; */
        if (message.retainage !== 0)
            writer.tag(19, WireType.Bit64).double(message.retainage);
        /* int32 revision_count = 20; */
        if (message.revisionCount !== 0)
            writer.tag(20, WireType.Varint).int32(message.revisionCount);
        /* string qb_invoice_id = 21; */
        if (message.qbInvoiceId !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.qbInvoiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectInvoice
 */
export const ProjectInvoice = new ProjectInvoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectInvoiceList$Type extends MessageType {
    constructor() {
        super("ProjectInvoiceList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectInvoice },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectInvoice results */ 1:
                    message.results.push(ProjectInvoice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectInvoice results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectInvoice.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectInvoiceList
 */
export const ProjectInvoiceList = new ProjectInvoiceList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceStatusRequest$Type extends MessageType {
    constructor() {
        super("InvoiceStatusRequest", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "new_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.newStatus = "";
        message.userId = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* string new_status */ 2:
                    message.newStatus = reader.string();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* string new_status = 2; */
        if (message.newStatus !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.newStatus);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceStatusRequest
 */
export const InvoiceStatusRequest = new InvoiceStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateInvoiceNumberRequest$Type extends MessageType {
    constructor() {
        super("GenerateInvoiceNumberRequest", [
            { no: 1, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectId = 0;
        message.projectEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_id */ 1:
                    message.projectId = reader.int32();
                    break;
                case /* int32 project_event_id */ 2:
                    message.projectEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_id = 1; */
        if (message.projectId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectId);
        /* int32 project_event_id = 2; */
        if (message.projectEventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GenerateInvoiceNumberRequest
 */
export const GenerateInvoiceNumberRequest = new GenerateInvoiceNumberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BackfillQBOInvoicesResponse$Type extends MessageType {
    constructor() {
        super("BackfillQBOInvoicesResponse", [
            { no: 1, name: "total_found", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "success_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "failure_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "errors", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalFound = 0;
        message.successCount = 0;
        message.failureCount = 0;
        message.errors = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_found */ 1:
                    message.totalFound = reader.int32();
                    break;
                case /* int32 success_count */ 2:
                    message.successCount = reader.int32();
                    break;
                case /* int32 failure_count */ 3:
                    message.failureCount = reader.int32();
                    break;
                case /* repeated string errors */ 4:
                    message.errors.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 total_found = 1; */
        if (message.totalFound !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalFound);
        /* int32 success_count = 2; */
        if (message.successCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.successCount);
        /* int32 failure_count = 3; */
        if (message.failureCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.failureCount);
        /* repeated string errors = 4; */
        for (let i = 0; i < message.errors.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.errors[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BackfillQBOInvoicesResponse
 */
export const BackfillQBOInvoicesResponse = new BackfillQBOInvoicesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnityBuildContract$Type extends MessageType {
    constructor() {
        super("UnityBuildContract", [
            { no: 1, name: "contract_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "project_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UnityBuildLineItem },
            { no: 5, name: "sync_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "last_sync", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = "";
        message.projectName = "";
        message.totalBudget = 0;
        message.lineItems = [];
        message.syncStatus = "";
        message.lastSync = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string contract_id */ 1:
                    message.contractId = reader.string();
                    break;
                case /* string project_name */ 2:
                    message.projectName = reader.string();
                    break;
                case /* double total_budget */ 3:
                    message.totalBudget = reader.double();
                    break;
                case /* repeated UnityBuildLineItem line_items */ 4:
                    message.lineItems.push(UnityBuildLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string sync_status */ 5:
                    message.syncStatus = reader.string();
                    break;
                case /* string last_sync */ 6:
                    message.lastSync = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string contract_id = 1; */
        if (message.contractId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contractId);
        /* string project_name = 2; */
        if (message.projectName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.projectName);
        /* double total_budget = 3; */
        if (message.totalBudget !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalBudget);
        /* repeated UnityBuildLineItem line_items = 4; */
        for (let i = 0; i < message.lineItems.length; i++)
            UnityBuildLineItem.internalBinaryWrite(message.lineItems[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string sync_status = 5; */
        if (message.syncStatus !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.syncStatus);
        /* string last_sync = 6; */
        if (message.lastSync !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.lastSync);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnityBuildContract
 */
export const UnityBuildContract = new UnityBuildContract$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnityBuildLineItem$Type extends MessageType {
    constructor() {
        super("UnityBuildLineItem", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mapped_department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "confidence_score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "master_format_division_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "master_format_division_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "mapped_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.description = "";
        message.amount = 0;
        message.category = "";
        message.mappedDepartment = "";
        message.confidenceScore = 0;
        message.masterFormatDivisionName = "";
        message.masterFormatDivisionId = "";
        message.mappedDepartmentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string description */ 1:
                    message.description = reader.string();
                    break;
                case /* double amount */ 2:
                    message.amount = reader.double();
                    break;
                case /* string category */ 3:
                    message.category = reader.string();
                    break;
                case /* string mapped_department */ 4:
                    message.mappedDepartment = reader.string();
                    break;
                case /* double confidence_score */ 5:
                    message.confidenceScore = reader.double();
                    break;
                case /* string master_format_division_name */ 6:
                    message.masterFormatDivisionName = reader.string();
                    break;
                case /* string master_format_division_id */ 7:
                    message.masterFormatDivisionId = reader.string();
                    break;
                case /* int32 mapped_department_id */ 8:
                    message.mappedDepartmentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string description = 1; */
        if (message.description !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.description);
        /* double amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Bit64).double(message.amount);
        /* string category = 3; */
        if (message.category !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.category);
        /* string mapped_department = 4; */
        if (message.mappedDepartment !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mappedDepartment);
        /* double confidence_score = 5; */
        if (message.confidenceScore !== 0)
            writer.tag(5, WireType.Bit64).double(message.confidenceScore);
        /* string master_format_division_name = 6; */
        if (message.masterFormatDivisionName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.masterFormatDivisionName);
        /* string master_format_division_id = 7; */
        if (message.masterFormatDivisionId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.masterFormatDivisionId);
        /* int32 mapped_department_id = 8; */
        if (message.mappedDepartmentId !== 0)
            writer.tag(8, WireType.Varint).int32(message.mappedDepartmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnityBuildLineItem
 */
export const UnityBuildLineItem = new UnityBuildLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportContractRequest$Type extends MessageType {
    constructor() {
        super("ImportContractRequest", [
            { no: 1, name: "contract_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "auto_create_project", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = "";
        message.autoCreateProject = false;
        message.propertyId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string contract_id */ 1:
                    message.contractId = reader.string();
                    break;
                case /* bool auto_create_project */ 2:
                    message.autoCreateProject = reader.bool();
                    break;
                case /* int32 property_id */ 3:
                    message.propertyId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string contract_id = 1; */
        if (message.contractId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contractId);
        /* bool auto_create_project = 2; */
        if (message.autoCreateProject !== false)
            writer.tag(2, WireType.Varint).bool(message.autoCreateProject);
        /* int32 property_id = 3; */
        if (message.propertyId !== 0)
            writer.tag(3, WireType.Varint).int32(message.propertyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ImportContractRequest
 */
export const ImportContractRequest = new ImportContractRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncBudgetRequest$Type extends MessageType {
    constructor() {
        super("SyncBudgetRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "contract_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "force_overwrite", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.contractId = "";
        message.forceOverwrite = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* string contract_id */ 2:
                    message.contractId = reader.string();
                    break;
                case /* bool force_overwrite */ 3:
                    message.forceOverwrite = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* string contract_id = 2; */
        if (message.contractId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.contractId);
        /* bool force_overwrite = 3; */
        if (message.forceOverwrite !== false)
            writer.tag(3, WireType.Varint).bool(message.forceOverwrite);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncBudgetRequest
 */
export const SyncBudgetRequest = new SyncBudgetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentMappingRequest$Type extends MessageType {
    constructor() {
        super("DepartmentMappingRequest", [
            { no: 1, name: "contract_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UnityBuildLineItem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = "";
        message.lineItems = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string contract_id */ 1:
                    message.contractId = reader.string();
                    break;
                case /* repeated UnityBuildLineItem line_items */ 2:
                    message.lineItems.push(UnityBuildLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string contract_id = 1; */
        if (message.contractId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contractId);
        /* repeated UnityBuildLineItem line_items = 2; */
        for (let i = 0; i < message.lineItems.length; i++)
            UnityBuildLineItem.internalBinaryWrite(message.lineItems[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentMappingRequest
 */
export const DepartmentMappingRequest = new DepartmentMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentMappingResponse$Type extends MessageType {
    constructor() {
        super("DepartmentMappingResponse", [
            { no: 1, name: "mappings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentMapping },
            { no: 2, name: "high_confidence_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "low_confidence_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.mappings = [];
        message.highConfidenceCount = 0;
        message.lowConfidenceCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated DepartmentMapping mappings */ 1:
                    message.mappings.push(DepartmentMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 high_confidence_count */ 2:
                    message.highConfidenceCount = reader.int32();
                    break;
                case /* int32 low_confidence_count */ 3:
                    message.lowConfidenceCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated DepartmentMapping mappings = 1; */
        for (let i = 0; i < message.mappings.length; i++)
            DepartmentMapping.internalBinaryWrite(message.mappings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 high_confidence_count = 2; */
        if (message.highConfidenceCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.highConfidenceCount);
        /* int32 low_confidence_count = 3; */
        if (message.lowConfidenceCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.lowConfidenceCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentMappingResponse
 */
export const DepartmentMappingResponse = new DepartmentMappingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentMapping$Type extends MessageType {
    constructor() {
        super("DepartmentMapping", [
            { no: 1, name: "line_item_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "allocated_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "confidence_score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.lineItemDescription = "";
        message.departmentId = 0;
        message.departmentName = "";
        message.allocatedBudget = 0;
        message.confidenceScore = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string line_item_description */ 1:
                    message.lineItemDescription = reader.string();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 3:
                    message.departmentName = reader.string();
                    break;
                case /* double allocated_budget */ 4:
                    message.allocatedBudget = reader.double();
                    break;
                case /* double confidence_score */ 5:
                    message.confidenceScore = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string line_item_description = 1; */
        if (message.lineItemDescription !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.lineItemDescription);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* string department_name = 3; */
        if (message.departmentName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.departmentName);
        /* double allocated_budget = 4; */
        if (message.allocatedBudget !== 0)
            writer.tag(4, WireType.Bit64).double(message.allocatedBudget);
        /* double confidence_score = 5; */
        if (message.confidenceScore !== 0)
            writer.tag(5, WireType.Bit64).double(message.confidenceScore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentMapping
 */
export const DepartmentMapping = new DepartmentMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncStatusRequest$Type extends MessageType {
    constructor() {
        super("SyncStatusRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncStatusRequest
 */
export const SyncStatusRequest = new SyncStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncStatusResponse$Type extends MessageType {
    constructor() {
        super("SyncStatusResponse", [
            { no: 1, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_sync_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "last_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_auto_sync_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = "";
        message.lastSyncTime = "";
        message.lastError = "";
        message.isAutoSyncEnabled = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string status */ 1:
                    message.status = reader.string();
                    break;
                case /* string last_sync_time */ 2:
                    message.lastSyncTime = reader.string();
                    break;
                case /* string last_error */ 3:
                    message.lastError = reader.string();
                    break;
                case /* bool is_auto_sync_enabled */ 4:
                    message.isAutoSyncEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string status = 1; */
        if (message.status !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.status);
        /* string last_sync_time = 2; */
        if (message.lastSyncTime !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastSyncTime);
        /* string last_error = 3; */
        if (message.lastError !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lastError);
        /* bool is_auto_sync_enabled = 4; */
        if (message.isAutoSyncEnabled !== false)
            writer.tag(4, WireType.Varint).bool(message.isAutoSyncEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncStatusResponse
 */
export const SyncStatusResponse = new SyncStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MobileProjectRequest$Type extends MessageType {
    constructor() {
        super("MobileProjectRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "status_filter", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.pageSize = 0;
        message.pageNumber = 0;
        message.statusFilter = "";
        message.departmentIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* int32 page_number */ 3:
                    message.pageNumber = reader.int32();
                    break;
                case /* string status_filter */ 4:
                    message.statusFilter = reader.string();
                    break;
                case /* repeated int32 department_ids */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIds.push(reader.int32());
                    else
                        message.departmentIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* int32 page_number = 3; */
        if (message.pageNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageNumber);
        /* string status_filter = 4; */
        if (message.statusFilter !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.statusFilter);
        /* repeated int32 department_ids = 5; */
        if (message.departmentIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIds.length; i++)
                writer.int32(message.departmentIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MobileProjectRequest
 */
export const MobileProjectRequest = new MobileProjectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MobileProjectSummary$Type extends MessageType {
    constructor() {
        super("MobileProjectSummary", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "budget_remaining", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "can_log_time", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "next_deadline", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.jobNumber = "";
        message.status = "";
        message.budgetRemaining = 0;
        message.percentComplete = 0;
        message.customerName = "";
        message.propertyAddress = "";
        message.canLogTime = false;
        message.nextDeadline = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string job_number */ 3:
                    message.jobNumber = reader.string();
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                case /* double budget_remaining */ 5:
                    message.budgetRemaining = reader.double();
                    break;
                case /* double percent_complete */ 6:
                    message.percentComplete = reader.double();
                    break;
                case /* string customer_name */ 7:
                    message.customerName = reader.string();
                    break;
                case /* string property_address */ 8:
                    message.propertyAddress = reader.string();
                    break;
                case /* bool can_log_time */ 9:
                    message.canLogTime = reader.bool();
                    break;
                case /* string next_deadline */ 10:
                    message.nextDeadline = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string job_number = 3; */
        if (message.jobNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.jobNumber);
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        /* double budget_remaining = 5; */
        if (message.budgetRemaining !== 0)
            writer.tag(5, WireType.Bit64).double(message.budgetRemaining);
        /* double percent_complete = 6; */
        if (message.percentComplete !== 0)
            writer.tag(6, WireType.Bit64).double(message.percentComplete);
        /* string customer_name = 7; */
        if (message.customerName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customerName);
        /* string property_address = 8; */
        if (message.propertyAddress !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.propertyAddress);
        /* bool can_log_time = 9; */
        if (message.canLogTime !== false)
            writer.tag(9, WireType.Varint).bool(message.canLogTime);
        /* string next_deadline = 10; */
        if (message.nextDeadline !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.nextDeadline);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MobileProjectSummary
 */
export const MobileProjectSummary = new MobileProjectSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MobileProjectList$Type extends MessageType {
    constructor() {
        super("MobileProjectList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MobileProjectSummary },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MobileProjectSummary results */ 1:
                    message.results.push(MobileProjectSummary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MobileProjectSummary results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MobileProjectSummary.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MobileProjectList
 */
export const MobileProjectList = new MobileProjectList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeEntryRequest$Type extends MessageType {
    constructor() {
        super("TimeEntryRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeEntryRequest
 */
export const TimeEntryRequest = new TimeEntryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeEntryData$Type extends MessageType {
    constructor() {
        super("TimeEntryData", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "allowed_department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "allows_overtime", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "project_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.projectName = "";
        message.allowedDepartmentIds = [];
        message.allowsOvertime = false;
        message.projectStatus = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* string project_name */ 2:
                    message.projectName = reader.string();
                    break;
                case /* repeated int32 allowed_department_ids */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.allowedDepartmentIds.push(reader.int32());
                    else
                        message.allowedDepartmentIds.push(reader.int32());
                    break;
                case /* bool allows_overtime */ 4:
                    message.allowsOvertime = reader.bool();
                    break;
                case /* string project_status */ 5:
                    message.projectStatus = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* string project_name = 2; */
        if (message.projectName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.projectName);
        /* repeated int32 allowed_department_ids = 3; */
        if (message.allowedDepartmentIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.allowedDepartmentIds.length; i++)
                writer.int32(message.allowedDepartmentIds[i]);
            writer.join();
        }
        /* bool allows_overtime = 4; */
        if (message.allowsOvertime !== false)
            writer.tag(4, WireType.Varint).bool(message.allowsOvertime);
        /* string project_status = 5; */
        if (message.projectStatus !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.projectStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeEntryData
 */
export const TimeEntryData = new TimeEntryData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeEntry$Type extends MessageType {
    constructor() {
        super("TimeEntry", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "time_in", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "time_out", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "total_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.userId = 0;
        message.departmentId = 0;
        message.timeIn = "";
        message.timeOut = "";
        message.totalHours = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* string time_in */ 4:
                    message.timeIn = reader.string();
                    break;
                case /* string time_out */ 5:
                    message.timeOut = reader.string();
                    break;
                case /* double total_hours */ 6:
                    message.totalHours = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* string time_in = 4; */
        if (message.timeIn !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.timeIn);
        /* string time_out = 5; */
        if (message.timeOut !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.timeOut);
        /* double total_hours = 6; */
        if (message.totalHours !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalHours);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeEntry
 */
export const TimeEntry = new TimeEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeEntryValidation$Type extends MessageType {
    constructor() {
        super("TimeEntryValidation", [
            { no: 1, name: "is_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "warnings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.isValid = false;
        message.errorMessage = "";
        message.warnings = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_valid */ 1:
                    message.isValid = reader.bool();
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                case /* repeated string warnings */ 3:
                    message.warnings.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool is_valid = 1; */
        if (message.isValid !== false)
            writer.tag(1, WireType.Varint).bool(message.isValid);
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        /* repeated string warnings = 3; */
        for (let i = 0; i < message.warnings.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.warnings[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeEntryValidation
 */
export const TimeEntryValidation = new TimeEntryValidation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateProjectRequest$Type extends MessageType {
    constructor() {
        super("CreateProjectRequest", [
            { no: 1, name: "project_data", kind: "message", T: () => Event },
            { no: 2, name: "department_assignments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentBudgetAllocation },
            { no: 3, name: "create_labor_rate_snapshot", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentAssignments = [];
        message.createLaborRateSnapshot = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Event project_data */ 1:
                    message.projectData = Event.internalBinaryRead(reader, reader.uint32(), options, message.projectData);
                    break;
                case /* repeated DepartmentBudgetAllocation department_assignments */ 2:
                    message.departmentAssignments.push(DepartmentBudgetAllocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool create_labor_rate_snapshot */ 3:
                    message.createLaborRateSnapshot = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Event project_data = 1; */
        if (message.projectData)
            Event.internalBinaryWrite(message.projectData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated DepartmentBudgetAllocation department_assignments = 2; */
        for (let i = 0; i < message.departmentAssignments.length; i++)
            DepartmentBudgetAllocation.internalBinaryWrite(message.departmentAssignments[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool create_labor_rate_snapshot = 3; */
        if (message.createLaborRateSnapshot !== false)
            writer.tag(3, WireType.Varint).bool(message.createLaborRateSnapshot);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateProjectRequest
 */
export const CreateProjectRequest = new CreateProjectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConvertToProjectRequest$Type extends MessageType {
    constructor() {
        super("ConvertToProjectRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "department_assignments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentBudgetAllocation }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.totalBudget = 0;
        message.departmentAssignments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* double total_budget */ 2:
                    message.totalBudget = reader.double();
                    break;
                case /* repeated DepartmentBudgetAllocation department_assignments */ 3:
                    message.departmentAssignments.push(DepartmentBudgetAllocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* double total_budget = 2; */
        if (message.totalBudget !== 0)
            writer.tag(2, WireType.Bit64).double(message.totalBudget);
        /* repeated DepartmentBudgetAllocation department_assignments = 3; */
        for (let i = 0; i < message.departmentAssignments.length; i++)
            DepartmentBudgetAllocation.internalBinaryWrite(message.departmentAssignments[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ConvertToProjectRequest
 */
export const ConvertToProjectRequest = new ConvertToProjectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectDashboardRequest$Type extends MessageType {
    constructor() {
        super("ProjectDashboardRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "include_recent_activities", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_budget_breakdown", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "include_invoice_summary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "include_health_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.includeRecentActivities = false;
        message.includeBudgetBreakdown = false;
        message.includeInvoiceSummary = false;
        message.includeHealthMetrics = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* bool include_recent_activities */ 2:
                    message.includeRecentActivities = reader.bool();
                    break;
                case /* bool include_budget_breakdown */ 3:
                    message.includeBudgetBreakdown = reader.bool();
                    break;
                case /* bool include_invoice_summary */ 4:
                    message.includeInvoiceSummary = reader.bool();
                    break;
                case /* bool include_health_metrics */ 5:
                    message.includeHealthMetrics = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* bool include_recent_activities = 2; */
        if (message.includeRecentActivities !== false)
            writer.tag(2, WireType.Varint).bool(message.includeRecentActivities);
        /* bool include_budget_breakdown = 3; */
        if (message.includeBudgetBreakdown !== false)
            writer.tag(3, WireType.Varint).bool(message.includeBudgetBreakdown);
        /* bool include_invoice_summary = 4; */
        if (message.includeInvoiceSummary !== false)
            writer.tag(4, WireType.Varint).bool(message.includeInvoiceSummary);
        /* bool include_health_metrics = 5; */
        if (message.includeHealthMetrics !== false)
            writer.tag(5, WireType.Varint).bool(message.includeHealthMetrics);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectDashboardRequest
 */
export const ProjectDashboardRequest = new ProjectDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectDashboard$Type extends MessageType {
    constructor() {
        super("ProjectDashboard", [
            { no: 1, name: "project_info", kind: "message", T: () => Event },
            { no: 2, name: "budget_summary", kind: "message", T: () => ProjectBudgetSummary },
            { no: 3, name: "recent_activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectActivity },
            { no: 4, name: "invoices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectInvoice },
            { no: 5, name: "department_assignments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectDepartmentAssignment },
            { no: 6, name: "unity_build_status", kind: "message", T: () => SyncStatusResponse },
            { no: 7, name: "health_metrics", kind: "message", T: () => ProjectHealthMetrics }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.recentActivities = [];
        message.invoices = [];
        message.departmentAssignments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Event project_info */ 1:
                    message.projectInfo = Event.internalBinaryRead(reader, reader.uint32(), options, message.projectInfo);
                    break;
                case /* ProjectBudgetSummary budget_summary */ 2:
                    message.budgetSummary = ProjectBudgetSummary.internalBinaryRead(reader, reader.uint32(), options, message.budgetSummary);
                    break;
                case /* repeated ProjectActivity recent_activities */ 3:
                    message.recentActivities.push(ProjectActivity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProjectInvoice invoices */ 4:
                    message.invoices.push(ProjectInvoice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated ProjectDepartmentAssignment department_assignments */ 5:
                    message.departmentAssignments.push(ProjectDepartmentAssignment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* SyncStatusResponse unity_build_status */ 6:
                    message.unityBuildStatus = SyncStatusResponse.internalBinaryRead(reader, reader.uint32(), options, message.unityBuildStatus);
                    break;
                case /* ProjectHealthMetrics health_metrics */ 7:
                    message.healthMetrics = ProjectHealthMetrics.internalBinaryRead(reader, reader.uint32(), options, message.healthMetrics);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Event project_info = 1; */
        if (message.projectInfo)
            Event.internalBinaryWrite(message.projectInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* ProjectBudgetSummary budget_summary = 2; */
        if (message.budgetSummary)
            ProjectBudgetSummary.internalBinaryWrite(message.budgetSummary, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProjectActivity recent_activities = 3; */
        for (let i = 0; i < message.recentActivities.length; i++)
            ProjectActivity.internalBinaryWrite(message.recentActivities[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProjectInvoice invoices = 4; */
        for (let i = 0; i < message.invoices.length; i++)
            ProjectInvoice.internalBinaryWrite(message.invoices[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated ProjectDepartmentAssignment department_assignments = 5; */
        for (let i = 0; i < message.departmentAssignments.length; i++)
            ProjectDepartmentAssignment.internalBinaryWrite(message.departmentAssignments[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* SyncStatusResponse unity_build_status = 6; */
        if (message.unityBuildStatus)
            SyncStatusResponse.internalBinaryWrite(message.unityBuildStatus, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* ProjectHealthMetrics health_metrics = 7; */
        if (message.healthMetrics)
            ProjectHealthMetrics.internalBinaryWrite(message.healthMetrics, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectDashboard
 */
export const ProjectDashboard = new ProjectDashboard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateProjectWithScopesRequest$Type extends MessageType {
    constructor() {
        super("CreateProjectWithScopesRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "department_scopes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentScopeEvent },
            { no: 5, name: "primary_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "po_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "project_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "project_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.propertyId = 0;
        message.userId = 0;
        message.departmentScopes = [];
        message.primaryDepartmentId = 0;
        message.poNumber = "";
        message.projectStartDate = "";
        message.projectEndDate = "";
        message.dateStarted = "";
        message.dateEnded = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* int32 property_id */ 2:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* repeated DepartmentScopeEvent department_scopes */ 4:
                    message.departmentScopes.push(DepartmentScopeEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 primary_department_id */ 5:
                    message.primaryDepartmentId = reader.int32();
                    break;
                case /* string po_number */ 6:
                    message.poNumber = reader.string();
                    break;
                case /* string project_start_date */ 7:
                    message.projectStartDate = reader.string();
                    break;
                case /* string project_end_date */ 8:
                    message.projectEndDate = reader.string();
                    break;
                case /* string date_started */ 9:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 10:
                    message.dateEnded = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* int32 property_id = 2; */
        if (message.propertyId !== 0)
            writer.tag(2, WireType.Varint).int32(message.propertyId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* repeated DepartmentScopeEvent department_scopes = 4; */
        for (let i = 0; i < message.departmentScopes.length; i++)
            DepartmentScopeEvent.internalBinaryWrite(message.departmentScopes[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 primary_department_id = 5; */
        if (message.primaryDepartmentId !== 0)
            writer.tag(5, WireType.Varint).int32(message.primaryDepartmentId);
        /* string po_number = 6; */
        if (message.poNumber !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.poNumber);
        /* string project_start_date = 7; */
        if (message.projectStartDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.projectStartDate);
        /* string project_end_date = 8; */
        if (message.projectEndDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.projectEndDate);
        /* string date_started = 9; */
        if (message.dateStarted !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 10; */
        if (message.dateEnded !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.dateEnded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateProjectWithScopesRequest
 */
export const CreateProjectWithScopesRequest = new CreateProjectWithScopesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentScopeEvent$Type extends MessageType {
    constructor() {
        super("DepartmentScopeEvent", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.name = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DepartmentScopeEvent
 */
export const DepartmentScopeEvent = new DepartmentScopeEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateProjectWithScopesResponse$Type extends MessageType {
    constructor() {
        super("CreateProjectWithScopesResponse", [
            { no: 1, name: "project", kind: "message", T: () => ProjectEvent },
            { no: 2, name: "created_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 3, name: "primary_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.createdEvents = [];
        message.primaryEventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* ProjectEvent project */ 1:
                    message.project = ProjectEvent.internalBinaryRead(reader, reader.uint32(), options, message.project);
                    break;
                case /* repeated Event created_events */ 2:
                    message.createdEvents.push(Event.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 primary_event_id */ 3:
                    message.primaryEventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* ProjectEvent project = 1; */
        if (message.project)
            ProjectEvent.internalBinaryWrite(message.project, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated Event created_events = 2; */
        for (let i = 0; i < message.createdEvents.length; i++)
            Event.internalBinaryWrite(message.createdEvents[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 primary_event_id = 3; */
        if (message.primaryEventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.primaryEventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateProjectWithScopesResponse
 */
export const CreateProjectWithScopesResponse = new CreateProjectWithScopesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormType$Type extends MessageType {
    constructor() {
        super("FormType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "email_destination", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.code = "";
        message.emailDestination = "";
        message.description = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string code */ 3:
                    message.code = reader.string();
                    break;
                case /* string email_destination */ 4:
                    message.emailDestination = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 9:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string code = 3; */
        if (message.code !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.code);
        /* string email_destination = 4; */
        if (message.emailDestination !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.emailDestination);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 9; */
        if (message.withoutLimit !== false)
            writer.tag(9, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormType
 */
export const FormType = new FormType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormTypeList$Type extends MessageType {
    constructor() {
        super("FormTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FormType results */ 1:
                    message.results.push(FormType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FormType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FormType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormTypeList
 */
export const FormTypeList = new FormTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormStatus$Type extends MessageType {
    constructor() {
        super("FormStatus", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.code = "";
        message.sortOrder = 0;
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string code */ 3:
                    message.code = reader.string();
                    break;
                case /* int32 sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 8:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string code = 3; */
        if (message.code !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.code);
        /* int32 sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 8; */
        if (message.withoutLimit !== false)
            writer.tag(8, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormStatus
 */
export const FormStatus = new FormStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormStatusList$Type extends MessageType {
    constructor() {
        super("FormStatusList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormStatus },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FormStatus results */ 1:
                    message.results.push(FormStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FormStatus results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FormStatus.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormStatusList
 */
export const FormStatusList = new FormStatusList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSubmission$Type extends MessageType {
    constructor() {
        super("FormSubmission", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "form_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "project_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "submitted_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "submitted_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "form_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "form_type_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "status_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "status_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "submitted_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "form_type", kind: "message", T: () => FormType },
            { no: 17, name: "form_status", kind: "message", T: () => FormStatus },
            { no: 18, name: "submitter", kind: "message", T: () => User },
            { no: 19, name: "documents", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSubmissionDocument },
            { no: 20, name: "subcontract_request", kind: "message", T: () => SubcontractRequestDetail },
            { no: 21, name: "nto_request", kind: "message", T: () => NTORequestDetail },
            { no: 22, name: "project_scope", kind: "message", T: () => ProjectScopeDetail },
            { no: 23, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "include_documents", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "include_details", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.formTypeId = 0;
        message.statusId = 0;
        message.projectName = "";
        message.eventId = 0;
        message.submittedBy = 0;
        message.submittedAt = "";
        message.createdAt = "";
        message.updatedAt = "";
        message.isActive = false;
        message.formTypeName = "";
        message.formTypeCode = "";
        message.statusName = "";
        message.statusCode = "";
        message.submittedByName = "";
        message.documents = [];
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.orderBy = "";
        message.orderDir = "";
        message.notEquals = [];
        message.dateRange = [];
        message.includeDocuments = false;
        message.includeDetails = false;
        message.dateTarget = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 form_type_id */ 2:
                    message.formTypeId = reader.int32();
                    break;
                case /* int32 status_id */ 3:
                    message.statusId = reader.int32();
                    break;
                case /* string project_name */ 4:
                    message.projectName = reader.string();
                    break;
                case /* int32 event_id */ 5:
                    message.eventId = reader.int32();
                    break;
                case /* int32 submitted_by */ 6:
                    message.submittedBy = reader.int32();
                    break;
                case /* string submitted_at */ 7:
                    message.submittedAt = reader.string();
                    break;
                case /* string created_at */ 8:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 9:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 10:
                    message.isActive = reader.bool();
                    break;
                case /* string form_type_name */ 11:
                    message.formTypeName = reader.string();
                    break;
                case /* string form_type_code */ 12:
                    message.formTypeCode = reader.string();
                    break;
                case /* string status_name */ 13:
                    message.statusName = reader.string();
                    break;
                case /* string status_code */ 14:
                    message.statusCode = reader.string();
                    break;
                case /* string submitted_by_name */ 15:
                    message.submittedByName = reader.string();
                    break;
                case /* FormType form_type */ 16:
                    message.formType = FormType.internalBinaryRead(reader, reader.uint32(), options, message.formType);
                    break;
                case /* FormStatus form_status */ 17:
                    message.formStatus = FormStatus.internalBinaryRead(reader, reader.uint32(), options, message.formStatus);
                    break;
                case /* User submitter */ 18:
                    message.submitter = User.internalBinaryRead(reader, reader.uint32(), options, message.submitter);
                    break;
                case /* repeated FormSubmissionDocument documents */ 19:
                    message.documents.push(FormSubmissionDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* SubcontractRequestDetail subcontract_request */ 20:
                    message.subcontractRequest = SubcontractRequestDetail.internalBinaryRead(reader, reader.uint32(), options, message.subcontractRequest);
                    break;
                case /* NTORequestDetail nto_request */ 21:
                    message.ntoRequest = NTORequestDetail.internalBinaryRead(reader, reader.uint32(), options, message.ntoRequest);
                    break;
                case /* ProjectScopeDetail project_scope */ 22:
                    message.projectScope = ProjectScopeDetail.internalBinaryRead(reader, reader.uint32(), options, message.projectScope);
                    break;
                case /* repeated string field_mask */ 23:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 24:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 25:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string order_by */ 26:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 27:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string not_equals */ 28:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated string date_range */ 29:
                    message.dateRange.push(reader.string());
                    break;
                case /* bool include_documents */ 30:
                    message.includeDocuments = reader.bool();
                    break;
                case /* bool include_details */ 31:
                    message.includeDetails = reader.bool();
                    break;
                case /* repeated string date_target */ 32:
                    message.dateTarget.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 form_type_id = 2; */
        if (message.formTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.formTypeId);
        /* int32 status_id = 3; */
        if (message.statusId !== 0)
            writer.tag(3, WireType.Varint).int32(message.statusId);
        /* string project_name = 4; */
        if (message.projectName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.projectName);
        /* int32 event_id = 5; */
        if (message.eventId !== 0)
            writer.tag(5, WireType.Varint).int32(message.eventId);
        /* int32 submitted_by = 6; */
        if (message.submittedBy !== 0)
            writer.tag(6, WireType.Varint).int32(message.submittedBy);
        /* string submitted_at = 7; */
        if (message.submittedAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.submittedAt);
        /* string created_at = 8; */
        if (message.createdAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 9; */
        if (message.updatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 10; */
        if (message.isActive !== false)
            writer.tag(10, WireType.Varint).bool(message.isActive);
        /* string form_type_name = 11; */
        if (message.formTypeName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.formTypeName);
        /* string form_type_code = 12; */
        if (message.formTypeCode !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.formTypeCode);
        /* string status_name = 13; */
        if (message.statusName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.statusName);
        /* string status_code = 14; */
        if (message.statusCode !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.statusCode);
        /* string submitted_by_name = 15; */
        if (message.submittedByName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.submittedByName);
        /* FormType form_type = 16; */
        if (message.formType)
            FormType.internalBinaryWrite(message.formType, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* FormStatus form_status = 17; */
        if (message.formStatus)
            FormStatus.internalBinaryWrite(message.formStatus, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* User submitter = 18; */
        if (message.submitter)
            User.internalBinaryWrite(message.submitter, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated FormSubmissionDocument documents = 19; */
        for (let i = 0; i < message.documents.length; i++)
            FormSubmissionDocument.internalBinaryWrite(message.documents[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* SubcontractRequestDetail subcontract_request = 20; */
        if (message.subcontractRequest)
            SubcontractRequestDetail.internalBinaryWrite(message.subcontractRequest, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* NTORequestDetail nto_request = 21; */
        if (message.ntoRequest)
            NTORequestDetail.internalBinaryWrite(message.ntoRequest, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* ProjectScopeDetail project_scope = 22; */
        if (message.projectScope)
            ProjectScopeDetail.internalBinaryWrite(message.projectScope, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 23; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(23, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 24; */
        if (message.pageNumber !== 0)
            writer.tag(24, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 25; */
        if (message.withoutLimit !== false)
            writer.tag(25, WireType.Varint).bool(message.withoutLimit);
        /* string order_by = 26; */
        if (message.orderBy !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 27; */
        if (message.orderDir !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string not_equals = 28; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(28, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated string date_range = 29; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(29, WireType.LengthDelimited).string(message.dateRange[i]);
        /* bool include_documents = 30; */
        if (message.includeDocuments !== false)
            writer.tag(30, WireType.Varint).bool(message.includeDocuments);
        /* bool include_details = 31; */
        if (message.includeDetails !== false)
            writer.tag(31, WireType.Varint).bool(message.includeDetails);
        /* repeated string date_target = 32; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(32, WireType.LengthDelimited).string(message.dateTarget[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormSubmission
 */
export const FormSubmission = new FormSubmission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSubmissionList$Type extends MessageType {
    constructor() {
        super("FormSubmissionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSubmission },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FormSubmission results */ 1:
                    message.results.push(FormSubmission.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FormSubmission results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FormSubmission.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormSubmissionList
 */
export const FormSubmissionList = new FormSubmissionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSubmissionDocument$Type extends MessageType {
    constructor() {
        super("FormSubmissionDocument", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "form_submission_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.formSubmissionId = 0;
        message.fileId = 0;
        message.description = "";
        message.createdAt = "";
        message.isActive = false;
        message.fileName = "";
        message.fileBucket = "";
        message.mimeType = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 form_submission_id */ 2:
                    message.formSubmissionId = reader.int32();
                    break;
                case /* int32 file_id */ 3:
                    message.fileId = reader.int32();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string created_at */ 5:
                    message.createdAt = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* string file_name */ 7:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 8:
                    message.fileBucket = reader.string();
                    break;
                case /* string mime_type */ 9:
                    message.mimeType = reader.string();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 12:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 form_submission_id = 2; */
        if (message.formSubmissionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.formSubmissionId);
        /* int32 file_id = 3; */
        if (message.fileId !== 0)
            writer.tag(3, WireType.Varint).int32(message.fileId);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string created_at = 5; */
        if (message.createdAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdAt);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* string file_name = 7; */
        if (message.fileName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 8; */
        if (message.fileBucket !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.fileBucket);
        /* string mime_type = 9; */
        if (message.mimeType !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.mimeType);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 12; */
        if (message.withoutLimit !== false)
            writer.tag(12, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormSubmissionDocument
 */
export const FormSubmissionDocument = new FormSubmissionDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormSubmissionDocumentList$Type extends MessageType {
    constructor() {
        super("FormSubmissionDocumentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FormSubmissionDocument },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FormSubmissionDocument results */ 1:
                    message.results.push(FormSubmissionDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FormSubmissionDocument results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FormSubmissionDocument.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FormSubmissionDocumentList
 */
export const FormSubmissionDocumentList = new FormSubmissionDocumentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubcontractRequestDetail$Type extends MessageType {
    constructor() {
        super("SubcontractRequestDetail", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "form_submission_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "is_new_subcontractor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "vetting_complete", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "project_csi_division_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "project_csi_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "coi_on_file", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "w9_on_file", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "subcontractor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "subcontractor_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "contract_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.formSubmissionId = 0;
        message.isNewSubcontractor = 0;
        message.vettingComplete = 0;
        message.projectCsiDivisionId = 0;
        message.projectCsiSubtypeId = 0;
        message.coiOnFile = 0;
        message.w9OnFile = 0;
        message.subcontractorName = "";
        message.subcontractorEmail = "";
        message.contractAmount = 0;
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 form_submission_id */ 2:
                    message.formSubmissionId = reader.int32();
                    break;
                case /* int32 is_new_subcontractor */ 3:
                    message.isNewSubcontractor = reader.int32();
                    break;
                case /* int32 vetting_complete */ 4:
                    message.vettingComplete = reader.int32();
                    break;
                case /* int32 project_csi_division_id */ 5:
                    message.projectCsiDivisionId = reader.int32();
                    break;
                case /* int32 project_csi_subtype_id */ 6:
                    message.projectCsiSubtypeId = reader.int32();
                    break;
                case /* int32 coi_on_file */ 7:
                    message.coiOnFile = reader.int32();
                    break;
                case /* int32 w9_on_file */ 8:
                    message.w9OnFile = reader.int32();
                    break;
                case /* string subcontractor_name */ 9:
                    message.subcontractorName = reader.string();
                    break;
                case /* string subcontractor_email */ 10:
                    message.subcontractorEmail = reader.string();
                    break;
                case /* double contract_amount */ 11:
                    message.contractAmount = reader.double();
                    break;
                case /* repeated string field_mask */ 12:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 form_submission_id = 2; */
        if (message.formSubmissionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.formSubmissionId);
        /* int32 is_new_subcontractor = 3; */
        if (message.isNewSubcontractor !== 0)
            writer.tag(3, WireType.Varint).int32(message.isNewSubcontractor);
        /* int32 vetting_complete = 4; */
        if (message.vettingComplete !== 0)
            writer.tag(4, WireType.Varint).int32(message.vettingComplete);
        /* int32 project_csi_division_id = 5; */
        if (message.projectCsiDivisionId !== 0)
            writer.tag(5, WireType.Varint).int32(message.projectCsiDivisionId);
        /* int32 project_csi_subtype_id = 6; */
        if (message.projectCsiSubtypeId !== 0)
            writer.tag(6, WireType.Varint).int32(message.projectCsiSubtypeId);
        /* int32 coi_on_file = 7; */
        if (message.coiOnFile !== 0)
            writer.tag(7, WireType.Varint).int32(message.coiOnFile);
        /* int32 w9_on_file = 8; */
        if (message.w9OnFile !== 0)
            writer.tag(8, WireType.Varint).int32(message.w9OnFile);
        /* string subcontractor_name = 9; */
        if (message.subcontractorName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.subcontractorName);
        /* string subcontractor_email = 10; */
        if (message.subcontractorEmail !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.subcontractorEmail);
        /* double contract_amount = 11; */
        if (message.contractAmount !== 0)
            writer.tag(11, WireType.Bit64).double(message.contractAmount);
        /* repeated string field_mask = 12; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SubcontractRequestDetail
 */
export const SubcontractRequestDetail = new SubcontractRequestDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NTORequestDetail$Type extends MessageType {
    constructor() {
        super("NTORequestDetail", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "form_submission_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.formSubmissionId = 0;
        message.startDate = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 form_submission_id */ 2:
                    message.formSubmissionId = reader.int32();
                    break;
                case /* string start_date */ 3:
                    message.startDate = reader.string();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 form_submission_id = 2; */
        if (message.formSubmissionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.formSubmissionId);
        /* string start_date = 3; */
        if (message.startDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.startDate);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NTORequestDetail
 */
export const NTORequestDetail = new NTORequestDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectScopeDetail$Type extends MessageType {
    constructor() {
        super("ProjectScopeDetail", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "form_submission_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "scope_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "project_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "project_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "subcontract_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "subcontract_work_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.formSubmissionId = 0;
        message.scopeDescription = "";
        message.projectStartDate = "";
        message.projectEndDate = "";
        message.subcontractPercentage = 0;
        message.subcontractWorkType = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 form_submission_id */ 2:
                    message.formSubmissionId = reader.int32();
                    break;
                case /* string scope_description */ 3:
                    message.scopeDescription = reader.string();
                    break;
                case /* string project_start_date */ 4:
                    message.projectStartDate = reader.string();
                    break;
                case /* string project_end_date */ 5:
                    message.projectEndDate = reader.string();
                    break;
                case /* double subcontract_percentage */ 6:
                    message.subcontractPercentage = reader.double();
                    break;
                case /* string subcontract_work_type */ 7:
                    message.subcontractWorkType = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 form_submission_id = 2; */
        if (message.formSubmissionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.formSubmissionId);
        /* string scope_description = 3; */
        if (message.scopeDescription !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.scopeDescription);
        /* string project_start_date = 4; */
        if (message.projectStartDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.projectStartDate);
        /* string project_end_date = 5; */
        if (message.projectEndDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.projectEndDate);
        /* double subcontract_percentage = 6; */
        if (message.subcontractPercentage !== 0)
            writer.tag(6, WireType.Bit64).double(message.subcontractPercentage);
        /* string subcontract_work_type = 7; */
        if (message.subcontractWorkType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.subcontractWorkType);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectScopeDetail
 */
export const ProjectScopeDetail = new ProjectScopeDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectCSIDivision$Type extends MessageType {
    constructor() {
        super("ProjectCSIDivision", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.code = "";
        message.description = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string code */ 3:
                    message.code = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 8:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string code = 3; */
        if (message.code !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.code);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 8; */
        if (message.withoutLimit !== false)
            writer.tag(8, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectCSIDivision
 */
export const ProjectCSIDivision = new ProjectCSIDivision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectCSIDivisionList$Type extends MessageType {
    constructor() {
        super("ProjectCSIDivisionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectCSIDivision },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectCSIDivision results */ 1:
                    message.results.push(ProjectCSIDivision.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectCSIDivision results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectCSIDivision.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectCSIDivisionList
 */
export const ProjectCSIDivisionList = new ProjectCSIDivisionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectCSISubtype$Type extends MessageType {
    constructor() {
        super("ProjectCSISubtype", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_csi_division_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.projectCsiDivisionId = 0;
        message.name = "";
        message.code = "";
        message.description = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 project_csi_division_id */ 2:
                    message.projectCsiDivisionId = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string code */ 4:
                    message.code = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 9:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 project_csi_division_id = 2; */
        if (message.projectCsiDivisionId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectCsiDivisionId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string code = 4; */
        if (message.code !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.code);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 9; */
        if (message.withoutLimit !== false)
            writer.tag(9, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectCSISubtype
 */
export const ProjectCSISubtype = new ProjectCSISubtype$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectCSISubtypeList$Type extends MessageType {
    constructor() {
        super("ProjectCSISubtypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectCSISubtype },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectCSISubtype results */ 1:
                    message.results.push(ProjectCSISubtype.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectCSISubtype results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectCSISubtype.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectCSISubtypeList
 */
export const ProjectCSISubtypeList = new ProjectCSISubtypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectEstimate$Type extends MessageType {
    constructor() {
        super("ProjectEstimate", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "estimate_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "estimate_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "estimate_labor_hours", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "estimate_direct_labor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "estimate_indirect_labor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "estimate_general_material", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "estimate_quoted_material", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "estimate_general_expense", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "estimate_equipment", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "estimate_subcontractor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "estimate_selling_price", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "lock_sell_price", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "project", kind: "message", T: () => ProjectEvent }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.projectId = 0;
        message.eventId = 0;
        message.estimateDate = "";
        message.estimateDescription = "";
        message.estimateLaborHours = 0;
        message.estimateDirectLabor = 0;
        message.estimateIndirectLabor = 0;
        message.estimateGeneralMaterial = 0;
        message.estimateQuotedMaterial = 0;
        message.estimateGeneralExpense = 0;
        message.estimateEquipment = 0;
        message.estimateSubcontractor = 0;
        message.estimateSellingPrice = 0;
        message.lockSellPrice = false;
        message.createdAt = "";
        message.updatedAt = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 project_id */ 2:
                    message.projectId = reader.int32();
                    break;
                case /* int32 event_id */ 3:
                    message.eventId = reader.int32();
                    break;
                case /* string estimate_date */ 4:
                    message.estimateDate = reader.string();
                    break;
                case /* string estimate_description */ 5:
                    message.estimateDescription = reader.string();
                    break;
                case /* int32 estimate_labor_hours */ 6:
                    message.estimateLaborHours = reader.int32();
                    break;
                case /* int32 estimate_direct_labor */ 7:
                    message.estimateDirectLabor = reader.int32();
                    break;
                case /* int32 estimate_indirect_labor */ 8:
                    message.estimateIndirectLabor = reader.int32();
                    break;
                case /* int32 estimate_general_material */ 9:
                    message.estimateGeneralMaterial = reader.int32();
                    break;
                case /* int32 estimate_quoted_material */ 10:
                    message.estimateQuotedMaterial = reader.int32();
                    break;
                case /* int32 estimate_general_expense */ 11:
                    message.estimateGeneralExpense = reader.int32();
                    break;
                case /* int32 estimate_equipment */ 12:
                    message.estimateEquipment = reader.int32();
                    break;
                case /* int32 estimate_subcontractor */ 13:
                    message.estimateSubcontractor = reader.int32();
                    break;
                case /* int32 estimate_selling_price */ 14:
                    message.estimateSellingPrice = reader.int32();
                    break;
                case /* bool lock_sell_price */ 15:
                    message.lockSellPrice = reader.bool();
                    break;
                case /* string created_at */ 16:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 17:
                    message.updatedAt = reader.string();
                    break;
                case /* bool is_active */ 18:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 19:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 20:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 21:
                    message.withoutLimit = reader.bool();
                    break;
                case /* ProjectEvent project */ 22:
                    message.project = ProjectEvent.internalBinaryRead(reader, reader.uint32(), options, message.project);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 project_id = 2; */
        if (message.projectId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectId);
        /* int32 event_id = 3; */
        if (message.eventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventId);
        /* string estimate_date = 4; */
        if (message.estimateDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.estimateDate);
        /* string estimate_description = 5; */
        if (message.estimateDescription !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.estimateDescription);
        /* int32 estimate_labor_hours = 6; */
        if (message.estimateLaborHours !== 0)
            writer.tag(6, WireType.Varint).int32(message.estimateLaborHours);
        /* int32 estimate_direct_labor = 7; */
        if (message.estimateDirectLabor !== 0)
            writer.tag(7, WireType.Varint).int32(message.estimateDirectLabor);
        /* int32 estimate_indirect_labor = 8; */
        if (message.estimateIndirectLabor !== 0)
            writer.tag(8, WireType.Varint).int32(message.estimateIndirectLabor);
        /* int32 estimate_general_material = 9; */
        if (message.estimateGeneralMaterial !== 0)
            writer.tag(9, WireType.Varint).int32(message.estimateGeneralMaterial);
        /* int32 estimate_quoted_material = 10; */
        if (message.estimateQuotedMaterial !== 0)
            writer.tag(10, WireType.Varint).int32(message.estimateQuotedMaterial);
        /* int32 estimate_general_expense = 11; */
        if (message.estimateGeneralExpense !== 0)
            writer.tag(11, WireType.Varint).int32(message.estimateGeneralExpense);
        /* int32 estimate_equipment = 12; */
        if (message.estimateEquipment !== 0)
            writer.tag(12, WireType.Varint).int32(message.estimateEquipment);
        /* int32 estimate_subcontractor = 13; */
        if (message.estimateSubcontractor !== 0)
            writer.tag(13, WireType.Varint).int32(message.estimateSubcontractor);
        /* int32 estimate_selling_price = 14; */
        if (message.estimateSellingPrice !== 0)
            writer.tag(14, WireType.Varint).int32(message.estimateSellingPrice);
        /* bool lock_sell_price = 15; */
        if (message.lockSellPrice !== false)
            writer.tag(15, WireType.Varint).bool(message.lockSellPrice);
        /* string created_at = 16; */
        if (message.createdAt !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 17; */
        if (message.updatedAt !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.updatedAt);
        /* bool is_active = 18; */
        if (message.isActive !== false)
            writer.tag(18, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 19; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 20; */
        if (message.pageNumber !== 0)
            writer.tag(20, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 21; */
        if (message.withoutLimit !== false)
            writer.tag(21, WireType.Varint).bool(message.withoutLimit);
        /* ProjectEvent project = 22; */
        if (message.project)
            ProjectEvent.internalBinaryWrite(message.project, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectEstimate
 */
export const ProjectEstimate = new ProjectEstimate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectEstimateList$Type extends MessageType {
    constructor() {
        super("ProjectEstimateList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectEstimate },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectEstimate results */ 1:
                    message.results.push(ProjectEstimate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectEstimate results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectEstimate.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectEstimateList
 */
export const ProjectEstimateList = new ProjectEstimateList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectProgressUpdate$Type extends MessageType {
    constructor() {
        super("ProjectProgressUpdate", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "snapshot_total_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "snapshot_spent_to_date", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "snapshot_budget_percent_spent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "creator", kind: "message", T: () => User },
            { no: 11, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.projectEventId = 0;
        message.percentComplete = 0;
        message.notes = "";
        message.snapshotTotalBudget = 0;
        message.snapshotSpentToDate = 0;
        message.snapshotBudgetPercentSpent = 0;
        message.createdBy = 0;
        message.createdAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 project_event_id */ 2:
                    message.projectEventId = reader.int32();
                    break;
                case /* double percent_complete */ 3:
                    message.percentComplete = reader.double();
                    break;
                case /* string notes */ 4:
                    message.notes = reader.string();
                    break;
                case /* double snapshot_total_budget */ 5:
                    message.snapshotTotalBudget = reader.double();
                    break;
                case /* double snapshot_spent_to_date */ 6:
                    message.snapshotSpentToDate = reader.double();
                    break;
                case /* double snapshot_budget_percent_spent */ 7:
                    message.snapshotBudgetPercentSpent = reader.double();
                    break;
                case /* int32 created_by */ 8:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_at */ 9:
                    message.createdAt = reader.string();
                    break;
                case /* User creator */ 10:
                    message.creator = User.internalBinaryRead(reader, reader.uint32(), options, message.creator);
                    break;
                case /* repeated string field_mask */ 11:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 12:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string order_by */ 14:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 15:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 project_event_id = 2; */
        if (message.projectEventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectEventId);
        /* double percent_complete = 3; */
        if (message.percentComplete !== 0)
            writer.tag(3, WireType.Bit64).double(message.percentComplete);
        /* string notes = 4; */
        if (message.notes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.notes);
        /* double snapshot_total_budget = 5; */
        if (message.snapshotTotalBudget !== 0)
            writer.tag(5, WireType.Bit64).double(message.snapshotTotalBudget);
        /* double snapshot_spent_to_date = 6; */
        if (message.snapshotSpentToDate !== 0)
            writer.tag(6, WireType.Bit64).double(message.snapshotSpentToDate);
        /* double snapshot_budget_percent_spent = 7; */
        if (message.snapshotBudgetPercentSpent !== 0)
            writer.tag(7, WireType.Bit64).double(message.snapshotBudgetPercentSpent);
        /* int32 created_by = 8; */
        if (message.createdBy !== 0)
            writer.tag(8, WireType.Varint).int32(message.createdBy);
        /* string created_at = 9; */
        if (message.createdAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.createdAt);
        /* User creator = 10; */
        if (message.creator)
            User.internalBinaryWrite(message.creator, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 11; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 12; */
        if (message.pageNumber !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        /* string order_by = 14; */
        if (message.orderBy !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 15; */
        if (message.orderDir !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectProgressUpdate
 */
export const ProjectProgressUpdate = new ProjectProgressUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectProgressUpdateList$Type extends MessageType {
    constructor() {
        super("ProjectProgressUpdateList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProjectProgressUpdate },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProjectProgressUpdate results */ 1:
                    message.results.push(ProjectProgressUpdate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProjectProgressUpdate results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProjectProgressUpdate.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectProgressUpdateList
 */
export const ProjectProgressUpdateList = new ProjectProgressUpdateList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProgressRequest$Type extends MessageType {
    constructor() {
        super("UpdateProgressRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.percentComplete = 0;
        message.notes = "";
        message.updatedBy = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* double percent_complete */ 2:
                    message.percentComplete = reader.double();
                    break;
                case /* string notes */ 3:
                    message.notes = reader.string();
                    break;
                case /* int32 updated_by */ 4:
                    message.updatedBy = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* double percent_complete = 2; */
        if (message.percentComplete !== 0)
            writer.tag(2, WireType.Bit64).double(message.percentComplete);
        /* string notes = 3; */
        if (message.notes !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.notes);
        /* int32 updated_by = 4; */
        if (message.updatedBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.updatedBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateProgressRequest
 */
export const UpdateProgressRequest = new UpdateProgressRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectHealthMetrics$Type extends MessageType {
    constructor() {
        super("ProjectHealthMetrics", [
            { no: 1, name: "days_elapsed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "daily_burn_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "weekly_burn_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "percent_budget_spent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "spent_to_date", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "manual_percent_complete", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "remaining_percent", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "projected_remaining_days", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "projected_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "projected_total_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "budget_efficiency", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "efficiency_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "total_budget", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "project_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "project_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "total_project_days", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "last_progress_update", kind: "message", T: () => ProjectProgressUpdate }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.daysElapsed = 0;
        message.dailyBurnRate = 0;
        message.weeklyBurnRate = 0;
        message.percentBudgetSpent = 0;
        message.spentToDate = 0;
        message.manualPercentComplete = 0;
        message.remainingPercent = 0;
        message.projectedRemainingDays = 0;
        message.projectedEndDate = "";
        message.projectedTotalCost = 0;
        message.budgetEfficiency = 0;
        message.efficiencyStatus = "";
        message.totalBudget = 0;
        message.projectStartDate = "";
        message.projectEndDate = "";
        message.totalProjectDays = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double days_elapsed */ 1:
                    message.daysElapsed = reader.double();
                    break;
                case /* double daily_burn_rate */ 2:
                    message.dailyBurnRate = reader.double();
                    break;
                case /* double weekly_burn_rate */ 3:
                    message.weeklyBurnRate = reader.double();
                    break;
                case /* double percent_budget_spent */ 4:
                    message.percentBudgetSpent = reader.double();
                    break;
                case /* double spent_to_date */ 5:
                    message.spentToDate = reader.double();
                    break;
                case /* double manual_percent_complete */ 6:
                    message.manualPercentComplete = reader.double();
                    break;
                case /* double remaining_percent */ 7:
                    message.remainingPercent = reader.double();
                    break;
                case /* double projected_remaining_days */ 8:
                    message.projectedRemainingDays = reader.double();
                    break;
                case /* string projected_end_date */ 9:
                    message.projectedEndDate = reader.string();
                    break;
                case /* double projected_total_cost */ 10:
                    message.projectedTotalCost = reader.double();
                    break;
                case /* double budget_efficiency */ 11:
                    message.budgetEfficiency = reader.double();
                    break;
                case /* string efficiency_status */ 12:
                    message.efficiencyStatus = reader.string();
                    break;
                case /* double total_budget */ 13:
                    message.totalBudget = reader.double();
                    break;
                case /* string project_start_date */ 14:
                    message.projectStartDate = reader.string();
                    break;
                case /* string project_end_date */ 15:
                    message.projectEndDate = reader.string();
                    break;
                case /* double total_project_days */ 16:
                    message.totalProjectDays = reader.double();
                    break;
                case /* ProjectProgressUpdate last_progress_update */ 17:
                    message.lastProgressUpdate = ProjectProgressUpdate.internalBinaryRead(reader, reader.uint32(), options, message.lastProgressUpdate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double days_elapsed = 1; */
        if (message.daysElapsed !== 0)
            writer.tag(1, WireType.Bit64).double(message.daysElapsed);
        /* double daily_burn_rate = 2; */
        if (message.dailyBurnRate !== 0)
            writer.tag(2, WireType.Bit64).double(message.dailyBurnRate);
        /* double weekly_burn_rate = 3; */
        if (message.weeklyBurnRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.weeklyBurnRate);
        /* double percent_budget_spent = 4; */
        if (message.percentBudgetSpent !== 0)
            writer.tag(4, WireType.Bit64).double(message.percentBudgetSpent);
        /* double spent_to_date = 5; */
        if (message.spentToDate !== 0)
            writer.tag(5, WireType.Bit64).double(message.spentToDate);
        /* double manual_percent_complete = 6; */
        if (message.manualPercentComplete !== 0)
            writer.tag(6, WireType.Bit64).double(message.manualPercentComplete);
        /* double remaining_percent = 7; */
        if (message.remainingPercent !== 0)
            writer.tag(7, WireType.Bit64).double(message.remainingPercent);
        /* double projected_remaining_days = 8; */
        if (message.projectedRemainingDays !== 0)
            writer.tag(8, WireType.Bit64).double(message.projectedRemainingDays);
        /* string projected_end_date = 9; */
        if (message.projectedEndDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.projectedEndDate);
        /* double projected_total_cost = 10; */
        if (message.projectedTotalCost !== 0)
            writer.tag(10, WireType.Bit64).double(message.projectedTotalCost);
        /* double budget_efficiency = 11; */
        if (message.budgetEfficiency !== 0)
            writer.tag(11, WireType.Bit64).double(message.budgetEfficiency);
        /* string efficiency_status = 12; */
        if (message.efficiencyStatus !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.efficiencyStatus);
        /* double total_budget = 13; */
        if (message.totalBudget !== 0)
            writer.tag(13, WireType.Bit64).double(message.totalBudget);
        /* string project_start_date = 14; */
        if (message.projectStartDate !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.projectStartDate);
        /* string project_end_date = 15; */
        if (message.projectEndDate !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.projectEndDate);
        /* double total_project_days = 16; */
        if (message.totalProjectDays !== 0)
            writer.tag(16, WireType.Bit64).double(message.totalProjectDays);
        /* ProjectProgressUpdate last_progress_update = 17; */
        if (message.lastProgressUpdate)
            ProjectProgressUpdate.internalBinaryWrite(message.lastProgressUpdate, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProjectHealthMetrics
 */
export const ProjectHealthMetrics = new ProjectHealthMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkFollowedUpRequest$Type extends MessageType {
    constructor() {
        super("MarkFollowedUpRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "interval_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.note = "";
        message.intervalDays = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* string note */ 2:
                    message.note = reader.string();
                    break;
                case /* int32 interval_days */ 3:
                    message.intervalDays = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* string note = 2; */
        if (message.note !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.note);
        /* int32 interval_days = 3; */
        if (message.intervalDays !== 0)
            writer.tag(3, WireType.Varint).int32(message.intervalDays);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkFollowedUpRequest
 */
export const MarkFollowedUpRequest = new MarkFollowedUpRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SnoozeFollowUpRequest$Type extends MessageType {
    constructor() {
        super("SnoozeFollowUpRequest", [
            { no: 1, name: "project_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "next_follow_up_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectEventId = 0;
        message.nextFollowUpDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 project_event_id */ 1:
                    message.projectEventId = reader.int32();
                    break;
                case /* string next_follow_up_date */ 2:
                    message.nextFollowUpDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 project_event_id = 1; */
        if (message.projectEventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.projectEventId);
        /* string next_follow_up_date = 2; */
        if (message.nextFollowUpDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextFollowUpDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SnoozeFollowUpRequest
 */
export const SnoozeFollowUpRequest = new SnoozeFollowUpRequest$Type();
/**
 * @generated ServiceType for protobuf service ProjectManagementService
 */
export const ProjectManagementService = new ServiceType("ProjectManagementService", [
    { name: "CreateProjectDepartmentAssignment", options: {}, I: ProjectDepartmentAssignment, O: ProjectDepartmentAssignment },
    { name: "GetProjectDepartmentAssignment", options: {}, I: ProjectDepartmentAssignment, O: ProjectDepartmentAssignment },
    { name: "BatchGetProjectDepartmentAssignment", options: {}, I: ProjectDepartmentAssignment, O: ProjectDepartmentAssignmentList },
    { name: "UpdateProjectDepartmentAssignment", options: {}, I: ProjectDepartmentAssignment, O: ProjectDepartmentAssignment },
    { name: "DeleteProjectDepartmentAssignment", options: {}, I: ProjectDepartmentAssignment, O: ProjectDepartmentAssignment },
    { name: "BulkAssignDepartments", options: {}, I: BulkDepartmentAssignRequest, O: ProjectDepartmentAssignmentList },
    { name: "CalculateProjectBudget", options: {}, I: BudgetCalculationRequest, O: ProjectBudgetSummary },
    { name: "GetDepartmentActuals", options: {}, I: BudgetCalculationRequest, O: BudgetBreakdown },
    { name: "GetItemizedActuals", options: {}, I: BudgetCalculationRequest, O: ItemizedActualsBreakdown },
    { name: "RecalculateAllProjectBudgets", options: {}, I: Empty, O: Bool },
    { name: "CreateProjectActivity", options: {}, I: ProjectActivity, O: ProjectActivity },
    { name: "BatchGetProjectActivity", options: {}, I: ProjectActivity, O: ProjectActivityList },
    { name: "LogStatusChange", options: {}, I: StatusChangeRequest, O: ProjectActivity },
    { name: "LogBudgetUpdate", options: {}, I: BudgetUpdateRequest, O: ProjectActivity },
    { name: "CreateProjectInvoice", options: {}, I: ProjectInvoice, O: ProjectInvoice },
    { name: "GetProjectInvoice", options: {}, I: ProjectInvoice, O: ProjectInvoice },
    { name: "BatchGetProjectInvoice", options: {}, I: ProjectInvoice, O: ProjectInvoiceList },
    { name: "UpdateProjectInvoice", options: {}, I: ProjectInvoice, O: ProjectInvoice },
    { name: "UpdateInvoiceStatus", options: {}, I: InvoiceStatusRequest, O: ProjectInvoice },
    { name: "GenerateInvoiceNumber", options: {}, I: GenerateInvoiceNumberRequest, O: String$ },
    { name: "DeleteProjectInvoice", options: {}, I: ProjectInvoice, O: ProjectInvoice },
    { name: "BackfillQBOInvoices", options: {}, I: Empty, O: BackfillQBOInvoicesResponse },
    { name: "ImportUnityBuildContract", options: {}, I: ImportContractRequest, O: UnityBuildContract },
    { name: "SyncContractBudget", options: {}, I: SyncBudgetRequest, O: ProjectBudgetSummary },
    { name: "MapDepartments", options: {}, I: DepartmentMappingRequest, O: DepartmentMappingResponse },
    { name: "GetSyncStatus", options: {}, I: SyncStatusRequest, O: SyncStatusResponse },
    { name: "GetUserProjects", options: {}, I: MobileProjectRequest, O: MobileProjectList },
    { name: "GetProjectTimeEntryData", options: {}, I: TimeEntryRequest, O: TimeEntryData },
    { name: "ValidateTimeEntry", options: {}, I: TimeEntry, O: TimeEntryValidation },
    { name: "CreateProjectFromEvent", options: {}, I: CreateProjectRequest, O: Event },
    { name: "ConvertServiceToProject", options: {}, I: ConvertToProjectRequest, O: Event },
    { name: "GetProjectDashboard", options: {}, I: ProjectDashboardRequest, O: ProjectDashboard },
    { name: "CreateProjectWithDepartmentScopes", options: {}, I: CreateProjectWithScopesRequest, O: Int32 },
    { name: "MarkProjectFollowedUp", options: {}, I: MarkFollowedUpRequest, O: Event },
    { name: "SnoozeProjectFollowUp", options: {}, I: SnoozeFollowUpRequest, O: Event },
    { name: "CreateFormSubmission", options: {}, I: FormSubmission, O: FormSubmission },
    { name: "GetFormSubmission", options: {}, I: FormSubmission, O: FormSubmission },
    { name: "BatchGetFormSubmission", options: {}, I: FormSubmission, O: FormSubmissionList },
    { name: "UpdateFormSubmission", options: {}, I: FormSubmission, O: FormSubmission },
    { name: "DeleteFormSubmission", options: {}, I: FormSubmission, O: FormSubmission },
    { name: "SubmitForm", options: {}, I: FormSubmission, O: FormSubmission },
    { name: "BatchGetFormType", options: {}, I: FormType, O: FormTypeList },
    { name: "BatchGetFormStatus", options: {}, I: FormStatus, O: FormStatusList },
    { name: "CreateFormSubmissionDocument", options: {}, I: FormSubmissionDocument, O: FormSubmissionDocument },
    { name: "BatchGetFormSubmissionDocument", options: {}, I: FormSubmissionDocument, O: FormSubmissionDocumentList },
    { name: "DeleteFormSubmissionDocument", options: {}, I: FormSubmissionDocument, O: FormSubmissionDocument },
    { name: "CreateSubcontractRequestDetail", options: {}, I: SubcontractRequestDetail, O: SubcontractRequestDetail },
    { name: "GetSubcontractRequestDetail", options: {}, I: SubcontractRequestDetail, O: SubcontractRequestDetail },
    { name: "UpdateSubcontractRequestDetail", options: {}, I: SubcontractRequestDetail, O: SubcontractRequestDetail },
    { name: "CreateNTORequestDetail", options: {}, I: NTORequestDetail, O: NTORequestDetail },
    { name: "GetNTORequestDetail", options: {}, I: NTORequestDetail, O: NTORequestDetail },
    { name: "UpdateNTORequestDetail", options: {}, I: NTORequestDetail, O: NTORequestDetail },
    { name: "CreateProjectScopeDetail", options: {}, I: ProjectScopeDetail, O: ProjectScopeDetail },
    { name: "GetProjectScopeDetail", options: {}, I: ProjectScopeDetail, O: ProjectScopeDetail },
    { name: "UpdateProjectScopeDetail", options: {}, I: ProjectScopeDetail, O: ProjectScopeDetail },
    { name: "BatchGetProjectCSIDivision", options: {}, I: ProjectCSIDivision, O: ProjectCSIDivisionList },
    { name: "BatchGetProjectCSISubtype", options: {}, I: ProjectCSISubtype, O: ProjectCSISubtypeList },
    { name: "CreateProjectEstimate", options: {}, I: ProjectEstimate, O: ProjectEstimate },
    { name: "GetProjectEstimate", options: {}, I: ProjectEstimate, O: ProjectEstimate },
    { name: "BatchGetProjectEstimate", options: {}, I: ProjectEstimate, O: ProjectEstimateList },
    { name: "UpdateProjectEstimate", options: {}, I: ProjectEstimate, O: ProjectEstimate },
    { name: "DeleteProjectEstimate", options: {}, I: ProjectEstimate, O: ProjectEstimate },
    { name: "UpdateProjectProgress", options: {}, I: UpdateProgressRequest, O: ProjectProgressUpdate },
    { name: "GetProjectProgressHistory", options: {}, I: ProjectProgressUpdate, O: ProjectProgressUpdateList },
    { name: "GetProjectHealthMetrics", options: {}, I: BudgetCalculationRequest, O: ProjectHealthMetrics }
]);
